"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _TransmuteCollection = require("./TransmuteCollection");

var makeObject = function makeObject() {
  return {};
};

_TransmuteCollection.keyedEquivalent.implement(Array, makeObject);

_TransmuteCollection.keyedEquivalent.implement(Object, makeObject);

_TransmuteCollection.keyedEquivalent.implementInherited(_immutable.Collection, function () {
  return (0, _immutable.Map)();
});

_TransmuteCollection.keyedEquivalent.implementInherited(_immutable.Seq, function () {
  return _immutable.Seq.Keyed();
});

var _default = _TransmuteCollection.keyedEquivalent;
exports.default = _default;
module.exports = exports.default;